import './AlertCardComponent.scss';

interface AlertCardComponentProps {
    message: any;
    action?: React.ReactNode;
    className?: string;
}

const AlertCardComponent = (props: AlertCardComponentProps) => {

    const {message, action, className} = props;

    return (
        <div className={`alert-card ${className}`}>
            <div className={'alert-card__message'}>
                {message}
            </div>
            {
                action && (
                    <div className="alert-card__action">
                        {action}
                    </div>
                )
            }

        </div>
    )
}
export default AlertCardComponent;
